import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import { setAcceptCurrentTermsAndConditions } from '../../../../common/actions/user/profile'
import { IRootState } from '../../../../common/reducers'
import { getUserProfile } from '../../../../common/selectors/user'
import TCBanner from './tcBanner'

interface IStateProps {
  acceptedCurrentTerms?: boolean
  isAuthor?: boolean
}

const mapStateToProps = (state: IRootState): IStateProps => {
  const profile = getUserProfile(state) || {}
  return {
    acceptedCurrentTerms: profile.accepted_current_terms,
    isAuthor: profile.is_author
  }
}

const mapDispatchToProps = (dispatch: Dispatch<IRootState>) => {
  return {
    onConfirm: () => {
      dispatch(setAcceptCurrentTermsAndConditions())
    }
  }
}

const TCBannerContainer = connect<IStateProps, any, any, IRootState>(
  mapStateToProps,
  mapDispatchToProps
)(TCBanner)

export default TCBannerContainer
